import { ReactNode, useMemo } from 'react'
import { Box } from '@mui/material'
import { FilterDropdown, FilterDropdownItemProps, Typography } from '@carto/meridian-ds/components'
import { CommonPrivacy } from 'features/common/types'
import { SharedOptionDescription } from './ShareOptionShared/ShareOptionShared'
import { PrivatePrivacy, PublicPrivacy, SharedPrivacy } from './SharingOptions'
import PrivacyIcon from './PrivacyIcon'

export const PrivacySettingsRadioGroup = ({
  value = CommonPrivacy.Shared,
  options = [PrivatePrivacy, SharedPrivacy, PublicPrivacy],
  description: customDescription,
  onChange,
  disabled
}: {
  value: CommonPrivacy
  onChange: (item: FilterDropdownItemProps) => void
  description?: ReactNode
  options?: FilterDropdownItemProps[]
  disabled?: boolean
}) => {
  const selectedOption = useMemo(() => options.find((po) => po.id === value), [value, options])
  const selectedOptionLabel = selectedOption?.label?.toString()

  const description = useMemo(() => {
    if (customDescription) {
      return customDescription
    } else if (value === CommonPrivacy.Shared) {
      return <SharedOptionDescription />
    } else {
      return selectedOption?.description
    }
  }, [customDescription, value, selectedOption])

  return (
    <Box display="flex" alignItems="center">
      <PrivacyIcon privacy={value} size="medium" aria-labelledby={selectedOptionLabel} />
      {disabled ? (
        <Typography id={selectedOptionLabel} sx={{ px: 2 }} variant="body1" weight="medium">
          {selectedOption?.label}
        </Typography>
      ) : (
        <FilterDropdown
          value={selectedOption}
          menuItems={options}
          buttonSize="large"
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          onClickItem={onChange}
          disabled={disabled}
        />
      )}
      <Box overflow="hidden">
        <Typography ml={0.5} variant="body2" color="textSecondary" component="div">
          {description}
        </Typography>
      </Box>
    </Box>
  )
}

export default PrivacySettingsRadioGroup
